import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import { GroupedPage } from '@mercadoni/sinister/dist/lib/src/entities/groupedPages'
import React, { FC, useCallback, useState } from 'react'
import styled from 'styled-components'
import DropdownGroup from './decorators/DropdownGroup'
import Link from './decorators/Link'

const StyledPagesContainer = styled.div`
  grid-area: customPages;
  display: flex;
  gap: var(--spacing-margin-medium);
  flex-grow: 1;
  overflow: hidden;
  justify-content: flex-end;
  align-items: center;
`

interface CustomPagesLayoutProps {
  groupedPages: GroupedPage[]
  maxItemsInline: number
}

const CustomPagesLayout: FC<CustomPagesLayoutProps> = ({
  groupedPages = [],
  maxItemsInline,
}) => {
  const [displayInDropdown, setDisplayInDropdown] = useState(false)
  const {
    colorSubheader: color,
    copies: { header: copy },
  } = useHeaderContext()
  const { moreDetails } = copy || {}

  const handleResize = (node: HTMLElement, pagesSize: number) => {
    const { clientWidth } = node
    setDisplayInDropdown(pagesSize > clientWidth)
  }

  // eslint-disable-next-line consistent-return
  const containerRef = useCallback((node: HTMLElement | null) => {
    if (node) {
      const offset = 20
      const pagesElements = node.querySelectorAll('.group-pages-item') || []
      let pagesSize: number

      if (pagesElements.length) {
        pagesSize = Array.from(pagesElements).reduce(
          (prev: number, curr: Element) =>
            (curr as HTMLElement).offsetWidth + prev + offset,
          0
        )
        const resizeObserver = new ResizeObserver(() => {
          handleResize(node, pagesSize)
        })

        resizeObserver.observe(node)

        return () => resizeObserver.disconnect()
      }
    }
  }, [])
  if (!groupedPages.length) {
    return <StyledPagesContainer data-testid="custom-pages" />
  }

  return (
    <StyledPagesContainer ref={containerRef} data-testid="custom-pages">
      {groupedPages.length <= maxItemsInline && !displayInDropdown ? (
        groupedPages.map((group) => {
          const { name, link, key, children } = group
          return (
            <React.Fragment key={key}>
              {children?.length ? (
                <DropdownGroup
                  className="group-pages-item"
                  items={children}
                  text={name || ''}
                />
              ) : (
                <Link
                  className="group-pages-item"
                  text={name || ''}
                  color={color}
                  path={link?.path || ''}
                  {...link}
                />
              )}
            </React.Fragment>
          )
        })
      ) : (
        <DropdownGroup items={groupedPages} text={moreDetails} />
      )}
    </StyledPagesContainer>
  )
}

export default CustomPagesLayout
